import React from 'react';
import './DashboardPreview.css';

export const DashboardPreview: React.FC = () => {
  return (
    <section className="dashboard-preview-section">
      <div className="dashboard-preview-container">
        <div className="dashboard-preview-header">
          <h2 className="dashboard-preview-title">Visualize suas métricas em tempo real</h2>
          <p className="dashboard-preview-subtitle">
            Dashboards interativos que mostram exatamente o que você precisa saber
          </p>
        </div>
        <div className="dashboard-mockup">
          <div className="mockup-header">
            <div className="mockup-header-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="mockup-header-title">Dashboard</div>
          </div>
          <div className="mockup-content">
            {/* Seção 1 - Métricas de Engenharia */}
            <div className="mockup-section-title">Métricas de Engenharia</div>
            <div className="mockup-metrics-row">
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">Mean Cycle Time</div>
                <div className="mockup-metric-value">2.3h</div>
                <div className="mockup-metric-trend up">↗ +12%</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">PRs Abertos</div>
                <div className="mockup-metric-value">24</div>
                <div className="mockup-metric-trend down">↘ -5%</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">Throughput</div>
                <div className="mockup-metric-value">45</div>
                <div className="mockup-metric-trend up">↗ +8%</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">Deploy Success</div>
                <div className="mockup-metric-value">98.5%</div>
                <div className="mockup-metric-trend up">↗ +2%</div>
              </div>
            </div>
            <div className="mockup-charts-row">
              <div className="mockup-chart-large">
                <div className="mockup-chart-title">PRs ao longo do tempo</div>
                <div className="mockup-chart-bars">
                  {[65, 80, 45, 90, 70, 85, 95, 75, 60, 88, 92, 78].map((height, i) => (
                    <div key={i} className="mockup-bar" style={{ height: `${height}%` }}></div>
                  ))}
                </div>
              </div>
              <div className="mockup-chart-small">
                <div className="mockup-chart-title">Deploy Frequency</div>
                <div className="mockup-line-chart">
                  <svg viewBox="0 0 200 100" className="mockup-line-svg">
                    <polyline
                      points="0,80 20,70 40,60 60,50 80,45 100,40 120,35 140,30 160,25 180,20 200,15"
                      fill="none"
                      stroke="var(--primary)"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Seção 2 - Performance de Contribuidores (Opindex) */}
            <div className="mockup-section-title" style={{ marginTop: '2rem' }}>Performance de Contribuidores</div>
            <div className="mockup-opindex-main-card">
              <div className="mockup-opindex-card">
                <div className="mockup-opindex-header">
                  <div className="mockup-metric-label">Opindex Médio</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Excelente</div>
                </div>
                <div className="mockup-metric-value">85.3</div>
              </div>
            </div>
            <div className="mockup-opindex-components">
              <div className="mockup-metric-card mockup-opindex-component">
                <div className="mockup-metric-label">Volume</div>
                <div className="mockup-metric-value">82.5</div>
                <div className="mockup-opindex-weight">30% do peso</div>
              </div>
              <div className="mockup-metric-card mockup-opindex-component">
                <div className="mockup-metric-label">Qualidade</div>
                <div className="mockup-metric-value">88.1</div>
                <div className="mockup-opindex-weight">30% do peso</div>
              </div>
              <div className="mockup-metric-card mockup-opindex-component">
                <div className="mockup-metric-label">Complexidade</div>
                <div className="mockup-metric-value">85.7</div>
                <div className="mockup-opindex-weight">25% do peso</div>
              </div>
              <div className="mockup-metric-card mockup-opindex-component">
                <div className="mockup-metric-label">Engajamento</div>
                <div className="mockup-metric-value">79.2</div>
                <div className="mockup-opindex-weight">15% do peso</div>
              </div>
            </div>
            <div className="mockup-table-section" style={{ marginTop: '1.5rem' }}>
              <div className="mockup-table-header">
                <div className="mockup-table-title">Top Contribuidores</div>
              </div>
              <div className="mockup-table">
                {[
                  { name: 'João Silva', prsMerged: 12, reviews: 45, opindex: 92.5 },
                  { name: 'Maria Santos', prsMerged: 10, reviews: 38, opindex: 87.3 },
                  { name: 'Pedro Costa', prsMerged: 8, reviews: 32, opindex: 76.2 }
                ].map((row, i) => {
                  const getOpindexColor = (opindex: number) => {
                    if (opindex >= 90) return '#7C4DFF'; // roxo
                    if (opindex >= 75) return '#22C55E'; // verde
                    if (opindex >= 50) return '#F59E0B'; // laranja
                    return '#EF4444'; // vermelho
                  };
                  return (
                    <div key={i} className="mockup-table-row mockup-table-row-opindex">
                      <div className="mockup-table-cell">{row.name}</div>
                      <div className="mockup-table-cell">{row.prsMerged} PRs</div>
                      <div className="mockup-table-cell">{row.reviews} Reviews</div>
                      <div className="mockup-table-cell">
                        <span style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '0.25rem',
                          backgroundColor: getOpindexColor(row.opindex),
                          color: 'white',
                          fontSize: '0.875rem',
                          fontWeight: '600'
                        }}>
                          {row.opindex.toFixed(1)}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Seção 3 - Gestão de Incidentes */}
            <div className="mockup-section-title" style={{ marginTop: '2rem' }}>Gestão de Incidentes</div>
            <div className="mockup-metrics-row">
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">MTTR</div>
                <div className="mockup-metric-value">4.2h</div>
                <div className="mockup-metric-trend down">↘ -15%</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">MTBF</div>
                <div className="mockup-metric-value">120h</div>
                <div className="mockup-metric-trend up">↗ +8%</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">Incidentes</div>
                <div className="mockup-metric-value">3</div>
                <div style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>No período</div>
              </div>
              <div className="mockup-metric-card">
                <div className="mockup-metric-label">Taxa de Resolução</div>
                <div className="mockup-metric-value">95%</div>
                <div className="mockup-metric-trend up">↗ +3%</div>
              </div>
            </div>
            <div className="mockup-charts-row">
              <div className="mockup-chart-large">
                <div className="mockup-chart-title">Incidentes por Severidade</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px', gap: '1rem' }}>
                  {[
                    { label: 'SEV-1', value: 1, color: '#EF4444' },
                    { label: 'SEV-2', value: 1, color: '#F59E0B' },
                    { label: 'SEV-3', value: 1, color: '#38BDF8' }
                  ].map((item, i) => (
                    <div key={i} style={{ textAlign: 'center' }}>
                      <div style={{
                        width: '80px',
                        height: `${60 + item.value * 20}px`,
                        backgroundColor: item.color,
                        borderRadius: '0.5rem',
                        marginBottom: '0.5rem'
                      }}></div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{item.label}</div>
                      <div style={{ fontSize: '0.875rem', fontWeight: '600', color: 'var(--text-primary)' }}>{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mockup-chart-small">
                <div className="mockup-chart-title">Incidentes ao longo do tempo</div>
                <div className="mockup-chart-bars">
                  {[20, 15, 25, 10, 30, 18, 22].map((height, i) => (
                    <div key={i} className="mockup-bar" style={{ height: `${height}%`, background: 'linear-gradient(180deg, var(--chart-5) 0%, #DC2626 100%)' }}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};









